export default {
  SET_USER_DATA({ commit }, payload) {
    commit('SET_USER_DATA', payload);
  },
  SET_CHANGE_PASSWORD_REQUIREMENT({ commit }, payload) {
    commit('SET_CHANGE_PASSWORD_REQUIREMENT', payload);
  },
};
